/**
 * Group the given iterable's values by the the value returned by the grouping
 * function. Each group is then passed to the mapFn and an array of the
 * mapped values is returned.
 *
 * @function groupFn
 * @param {*} value each value of obj
 * @param {*} key corresponding key of obj
 * @returns {*} a value to group by
 *
 * @function mapFn
 * @param {*} groupValue the group value
 * @params {[*, *]} groupEntries the key-value pairs matching the groupValue
 * @returns {*} the element of the final array to return this group
 *
 * @param  {IterableCollection} obj
 * @param {groupBy} groupBy
 * @param {mapFn} mapFn
 * @return {[*]}
 */
export default function groupBy (obj, groupFn = (value, _key) => value, mapFn = (groupValue, groupEntries) => [groupValue, groupEntries]) {
  if (!this.isIterable(obj)) {
    throw new Error(`Cannot count non-iterable object: ${obj}`);
  }
  let groups = new Map();
  for (let [key, value] of this.entries(obj)) {
    let groupValue = groupFn(value, key);
    if (!groups.has(groupValue)) {
      groups.set(groupValue, []);
    }
    groups.get(groupValue).push([key, value]);
  }
  return Array.from(groups.entries()).map(mapFn);
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/groupBy.js